// Dynamically loads the Razorpay Checkout script if not already present.
// This app has no static <script> tag for it (unlike psych_appointment_app_FE,
// which already needed one) - shared here since the subscription lock
// screen and the Settings Subscription tab both need Razorpay Checkout.
export const loadRazorpay = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const existing = document.querySelector('script[src*="checkout.razorpay.com"]');
    const script = existing || document.createElement("script");
    script.onload = () => resolve(!!window.Razorpay);
    script.onerror = () => resolve(false);
    if (!existing) {
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      document.body.appendChild(script);
    } else {
      const poll = setInterval(() => {
        if (window.Razorpay) {
          clearInterval(poll);
          resolve(true);
        }
      }, 200);
      setTimeout(() => clearInterval(poll), 5000);
    }
  });
